import {i18nException, InvalidTokenException} from '@/models/Exceptions';
import {MAX_API_ATTEMPTS} from '@/constants';

export const isInvalidTokenException = (error: Error) => {
  if (error instanceof i18nException) {
    return error.type === 'InvalidTokenException';
  }
  return error instanceof InvalidTokenException;
}

export const shouldRetry = (failureCount: number, error: Error) => {
  const isMaxAttemptsReached = failureCount >= MAX_API_ATTEMPTS - 1;
  return !isMaxAttemptsReached && isInvalidTokenException(error);
};
